import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import ContactSection from '../components/ContactSection';

const ContactPage: React.FC = () => {
  return (
    <>
      <section className="section bg-light-gray">
        <Container>
          <Row className="justify-content-center">
            <Col lg={8} className="text-center">
              <h1>संपर्क करा</h1>
              <p className="lead mb-5">
                आमच्या सेवा संदर्भात तुम्हाला काही प्रश्न असतील तर आम्हाला नक्की संपर्क करा.
                आम्ही शक्य तितक्या लवकर उत्तर देण्याचा प्रयत्न करू.
              </p>
            </Col>
          </Row>
        </Container>
      </section>
      
      <ContactSection />
      
      <section className="section">
        <Container>
          <Row className="justify-content-center">
            <Col lg={10}>
              <div className="bg-light-gray p-4 rounded">
                <h3 className="mb-4 text-center">आमचे कार्यालय भेट द्या</h3>
                <div className="text-center mb-4">
                  <p className="mb-0">जीवन आधार विमा सेवा केंद्र</p>
                  <p className="mb-0">टेंभुर्णी, 413211, महाराष्ट्र</p>
                  <p className="mb-0">भारत</p>
                </div>

                <div className="map-container">
                  <iframe
                    title="Google Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3793.9530669826554!2d75.1983048!3d18.0273816!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc46f8e53d1668d%3A0x2b7909e332334973!2sJEEVAN%20ADHAAR%20VIMA%20SEVA%20KENDRA%20%2C%20TEMBHURNI!5e0!3m2!1sen!2sin!4v1748544972895!5m2!1sen!2sin"
                    width="100%"
                    height="450"
                    style={{ border: 0, borderRadius: 'var(--border-radius-md)' }}
                    allowFullScreen
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                  ></iframe>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ContactPage;
